module.exports = __webpack_public_path__ + "static/media/speaker_HKChinaGas_CheungPakKin.78d082d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_HKChinaGas_CheungPakKin.jpg
// module id = 257
// module chunks = 0